import React from 'react';
import { Outlet } from 'react-router-dom';
import MyPageHeader from './MyPageHeader';
import MoveToTop from '../MoveTotop/MoveToTop';
import Footer from '../Footer/Footer';

function MyPage() {
  return (
    <div>
      <MyPageHeader />
      <div className="contents"><Outlet /></div>
      <Footer />
      <MoveToTop />
    </div>
  );
}

export default MyPage;
